import Cookies from 'js-cookie';

const userInfo = {};

export function getInfo() {
  return userInfo;
}

export function setInfo(data, serverInfo) {
  userInfo.expiry = new Date(parseInt(data.exp_date + '000'));
  userInfo.username = data.username;
  userInfo.password = data.password;
  userInfo.max_connections = data.max_connections;
  userInfo.message = data.message;

  // EPG initialization removed - now using Xtream Codes API directly

  Cookies.set('username', data.username, { expires: 365 });
  Cookies.set('password', data.password, { expires: 365 });
}

export function logout(callback) {
  Cookies.remove('dns');
  Cookies.remove('username');
  Cookies.remove('password');
  if (callback && typeof callback === 'function') {
    callback();
  } else {
    window.location = '/';
  }
}
